import { TrainerEditor } from "./TrainerEditor";
import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import type { TrainerEditorState } from "./TrainerEditor";
import type { Control } from "react-hook-form";

export function TrainerEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<TrainerEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <TrainerEditor control={control} />
    </FormConfirmDialog>
  );
}
